// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IPlanResponseDto
 */
export interface IPlanResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IPlanResponseDto
     */
    plan_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IPlanResponseDto
     */
    plan_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IPlanResponseDto
     */
    account_type?: IPlanResponseDtoAccountTypeEnum;
}

/**
* @export
* @enum {string}
*/
export enum IPlanResponseDtoAccountTypeEnum {
    HSA = 'HSA',
    HCFSA = 'HCFSA',
    HRA = 'HRA',
    DCAP = 'DCAP',
    EXTERNAL = 'EXTERNAL',
    CLEARING = 'CLEARING',
    SUB_ACCOUNT = 'SUB_ACCOUNT',
    OMNIBUS = 'OMNIBUS',
    PARKING = 'PARKING',
    TRANSIT = 'TRANSIT',
    ADOPTION = 'ADOPTION',
    SPECIALTY = 'SPECIALTY',
    LIFESTYLE = 'LIFESTYLE',
    WAGEPARITY = 'WAGEPARITY',
    PLAN_OMNIBUS = 'PLAN_OMNIBUS',
    NOTIONAL_PAYROLL = 'NOTIONAL_PAYROLL',
    NOTIONAL_FUNDING = 'NOTIONAL_FUNDING',
    TRAVEL = 'TRAVEL'
}


/**
 * Check if a given object implements the IPlanResponseDto interface.
 */
export function instanceOfIPlanResponseDto(value: object): value is IPlanResponseDto {
    return true;
}

export function IPlanResponseDtoFromJSON(json: any): IPlanResponseDto {
    return IPlanResponseDtoFromJSONTyped(json, false);
}

export function IPlanResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPlanResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_id': json['plan_id'] == null ? undefined : json['plan_id'],
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'account_type': json['account_type'] == null ? undefined : json['account_type'],
    };
}

export function IPlanResponseDtoToJSON(json: any): IPlanResponseDto {
    return IPlanResponseDtoToJSONTyped(json, false);
}

export function IPlanResponseDtoToJSONTyped(value?: IPlanResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_id': value['plan_id'],
        'plan_name': value['plan_name'],
        'account_type': value['account_type'],
    };
}

